import { useTranslations } from 'next-intl';
import { CatHeading } from 'components/blocks-components';
import styles from './product-diagram-title.module.scss';

type ProductDiagramTitleProps = {
  model: string;
  partNumber: string;
  partName: string;
};

const ProductDiagramTitle = ({
  model,
  partNumber,
  partName
}: ProductDiagramTitleProps) => {
  const t = useTranslations();

  return (
    <div className="cat-u-padding-bottom-md">
      <CatHeading className={styles['product-diagram-title']} variant="title">
        {`${model} ${t('CAT_PARTS_DIAGRAM')} ${t('SIS_WITH')} ${partNumber}: ${partName}`}
      </CatHeading>
    </div>
  );
};

export default ProductDiagramTitle;
